import React from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect, dispatch } from 'react-redux';
import { firebaseConnect, isLoaded, isEmpty, helpers as firebaseHelpers } from 'react-redux-firebase'
import Link from 'gatsby-link'
import Footer from './Footer'
import Header from './Header'
import Subscribe from './Subscribe'
import { withRouter } from 'react-router';
import ParkyHandsInPocket from '../images/Parky_cool_orange.png';
import ParkyHomeMobile from '../images/Parky home mobile.png';
import ParkyAboutMobile from '../images/Parky about mobile.png';
import ParkyPrivacyMobile from '../images/Parky privacy mobile.png';
import ParkyFAQMobile from '../images/Parky FAQ mobile.png';
import ParkyContactMobile from '../images/Parky contact us mobile.png';
import PropTypes from 'prop-types'; // ES6
import PlayStore from '../images/google-play-badge.png';
import AppStore from '../images/app-store-badge.png';

class ContentLeft extends React.Component {
  constructor(props) {
    super(props);
  }

  renderPromo(name){
    if (this.props.location.pathname == '/') {
      return(
        <div className={`promo-${name}`}>
        <iframe width="100%" height={name == 'mobile' ? "200" : "250"} src="https://www.youtube.com/embed/b9IG0J6wWUY" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
          <div className="store-badges">
            <a className="play-store" href="https://parkyou.app.link/HCLbJgefrR" target="_blank">
              <img  src={PlayStore} />
            </a>
            <a className="app-store" href="https://parkyou.app.link/HCLbJgefrR" target="_blank">
              <img  src={AppStore} />
            </a>
          </div>
        </div>
      )
    }
  }
  render() {

    const { location, children } = this.props
    let pageClass = this.props.location.pathname.substr(1).length ? this.props.location.pathname.substr(1) : 'home';

    return (
      <div id="content-left" className={`content ${pageClass}`}>
        <Header location={location}/>
        <div id="page" className={`mobile intro ${this.props.state.subscribe && this.props.state.subscribe.isSubscribeVisible ? 'expanded' : ''} ${this.props.location.pathname !== '/' ? 'has-parky' : ''}`}>
          <div className="parky">
              {this.renderPromo("mobile")}
              <img src={ParkyHandsInPocket} style={{ objectFit: 'contain', display: this.props.location.pathname.match('/community-rules') ?  'block' : 'none'}}/>
              <img src={ParkyHandsInPocket} style={{ objectFit: 'contain', display: this.props.location.pathname.match('/referred') ?  'block' : 'none'}}/>
              <img alt="Hoodie Parky, ParkYou's mascot spokesdog in his custom orange hoodie" src={ParkyAboutMobile}  style={{display: this.props.location.pathname.indexOf('/about') !== -1 ?  'block' : 'none'}}/>
              <img alt="Hoodie Parky, ParkYou's mascot spokesdog in his custom orange hoodie"  src={ParkyPrivacyMobile}  style={{display: this.props.location.pathname.indexOf('/privacy') !== -1 ?  'block' : 'none'}}/>
              <img alt="Hoodie Parky, ParkYou's mascot spokesdog in his custom orange hoodie"  src={ParkyFAQMobile}  style={{display: this.props.location.pathname.indexOf('/faq') !== -1 ?  'block' : 'none'}}/>
              <img alt="Hoodie Parky, ParkYou's mascot spokesdog in his custom orange hoodie"  src={ParkyContactMobile}  style={{display: this.props.location.pathname.indexOf('/contact') !== -1 ?  'block' : 'none'}}/>
          </div>
        </div>

        {this.renderPromo('desktop')}

        <div id="page" className={`mobile-up intro ${this.props.state.subscribe && this.props.state.subscribe.isSubscribeVisible ? 'expanded' : ''} ${this.props.location.pathname !== '/' ? 'has-parky' : ''}`}>
          <div className="article" id="intro">
            <Subscribe />
          </div>
          <div className="parky">
              <img src={ParkyHandsInPocket}/>
          </div>
        </div>
        <Footer timeout={this.props.state.timeout} location={this.props.location} />
      </div>
    )
  }
}

ContentLeft.propTypes = {
  route: PropTypes.object,
  article: PropTypes.string,
  articleTimeout: PropTypes.bool,
  onCloseArticle: PropTypes.func,
  timeout: PropTypes.bool
}

const  mapStateToProps = ({app, firebase}) => ({
  state: {
    subscribe: app.subscribe,
    dashboard: firebase.data.dashboard
  }
})

const mapDispatchToProps = dispatch => ({
})

export default compose(
  firebaseConnect([
    'dashboard' // { path: '/todos' } // object notation
  ]),
  connect(
      mapStateToProps,
      mapDispatchToProps
  )
)(withRouter(ContentLeft))


// WEBPACK FOOTER //
// ./src/components/ContentLeft.js